export default __webpack_public_path__ + "static/media/R870_9.b9bc4865.png";